import { required } from "../../shared/src/codecs/types/required";
import { string } from "../../shared/src/codecs/types/string";
import { uuid } from "../../shared/src/codecs/types/uuid";

export const User9 = required({
    id: uuid(),
    first_name: string(),
    last_name: string(),
});